<template>
	<div class="updates mh-700">
		<v-layout row wrap>
			<v-flex xs12>
				<ViewHeader
					src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Flonely-road-h800.jpg?alt=media&token=553a7542-9b8b-40ff-ac99-b319033a3d54"
					title="Updates"
				/>
			</v-flex>
		</v-layout>

		<v-container>
			<v-row justify="center">
				<v-col sm="12">
					<div class="update-photo-wrapper">
						<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FTravelAwardee1.jpg?alt=media&token=446b1779-a76a-4e48-94da-afd653cb0c77">						
					</div>			
				</v-col>											
			</v-row>
			<p class="photo-caption">Journal for Neurochemistry Awardees</p>
			<v-row justify="center">
				<v-col sm="12" md="5">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FTravelAwardee2-small.jpg?alt=media&token=0b575e21-4777-4b56-9289-acef0520a0f3">
				</v-col>
				<v-col sm="12" md="3">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FTravelAwardee3-small.jpg?alt=media&token=56f833cb-4e72-41ec-b1ba-25f6bfd1c5f3">
				</v-col>
			</v-row>
			<p class="photo-caption">ISCBFM Travel Award Winners</p>
			<v-row justify="center">
				<v-col sm="12">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FLargeGroup2.jpg?alt=media&token=e42e6256-b282-4949-ab1b-03026671040e">
				</v-col>
			</v-row>
			<p class="photo-caption">Student/Postdoctoral Fellow Travel Awardees and Session Chairs (Drs. Jordi Duran and Phil Lee)</p>
			<v-row justify="center">
				<v-col sm="12">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FIMG_1041.jpg?alt=media&token=1ab9b409-7760-48b4-b40e-b3f8bc8bfbd0">
				</v-col>
			</v-row>
			<p class="photo-caption">ICBEM 2022 Welcome by Dr. In-Young Choi</p>
			<v-row justify="center">
				<v-col sm="12" md="5">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FPosterSession2-small.jpg?alt=media&token=6540b11a-b91e-48f6-92c2-7e0c67bdfb50">
				</v-col>
				<v-col sm="12" md="5">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FConvoByPosters-small.jpg?alt=media&token=a42ec566-cd1c-472b-b6ef-ba7c06fd3004">
				</v-col>
			</v-row>
			<v-row justify="space-around">
				<v-col sm="12" md="6">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FPresentation.jpg?alt=media&token=d48a90e8-2e3d-41f3-95e5-b917bff83e6d">
				</v-col>
				<v-col sm="12" md="6">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FDuringSession.jpg?alt=media&token=36925bc2-619f-468e-b4ec-565a2e5e41c4">
				</v-col>
			</v-row>
			<v-row justify="space-around">
				<v-col sm="12" md="6">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2Ferukainure.jpg?alt=media&token=2a823b7a-38e8-428f-bbaa-8c26a4cfc87a">
					<p class="photo-caption">Ochuko Erukainure</p>
				</v-col>
				<v-col sm="12" md="6">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FPosterSession.jpg?alt=media&token=98640cc2-ac6c-4300-b9f0-d2076f16e3e7">
					<p class="photo-caption">Poster Session</p>
				</v-col>
			</v-row>
			<v-row justify="space-around" >
				<v-col md="12" lg="6">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FIMG_1065.jpg?alt=media&token=889d8827-2e30-483a-b591-cdc633a657d9">
				</v-col>
				<v-col md="12" lg="6">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FIMG_1072.jpg?alt=media&token=c52361f3-8525-4eef-80b8-2d3af3ab6b76">
				</v-col>
				<v-col md="12" lg="6">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FIMG_1074.jpg?alt=media&token=b86e2983-5054-4b66-bc33-75c282af6b10">
				</v-col>
			</v-row>
			<p class="photo-caption">Organizing and Program Committee Members</p>
			<v-row justify="center">
				<v-col sm="12">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FIMG_1077.jpg?alt=media&token=463190c9-ee65-4fb5-85d4-8408ff2d492d">
				</v-col>
			</v-row>
			<p class="photo-caption">Program Committee Members (Drs. Rae, Choi and Barros)</p>
			<v-row justify="center">
				<v-col md="12" lg="6">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FIMG_1050.jpg?alt=media&token=1933dcb2-e33f-4611-baea-11a580650b02">
				</v-col>
				<v-col md="12" lg="6">
					<img class="update-photo" src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fconference%2FIMG_1046.jpg?alt=media&token=d66ff6ea-39d6-43ab-a2df-b80343d297fe">
				</v-col>
			</v-row>
			<p class="photo-caption">Conference Chairs and participants at the Bandelier National Monument</p>
		</v-container>
	</div>
</template>
<script>
import ViewHeader from '@/components/ViewHeader.vue';
export default {
	name: 'Updates',
	components: {
		ViewHeader
	},
	methods: {
		navigateToAccount: function() {
			this.$router.push('/account').catch(() => { });
		}
	}
};
</script>
<style src="../style.css"></style>

